export default __webpack_public_path__ + "static/media/page7Image1l.e6473555.png";